/**
 * FAB Component - Template
 * ========================
 */

import { BASE_CLASSES } from './constants';

export const FAB_TEMPLATE: string = `
<div class="ec-fab ${BASE_CLASSES.wrapper}">
  <button
    ng-attr-type="{{ $ctrl.type }}"
    ng-class="$ctrl.getButtonClasses()"
    ng-disabled="$ctrl.isDisabled"
    ng-attr-aria-disabled="{{ $ctrl.isDisabled ? 'true' : undefined }}"
    ng-attr-aria-busy="{{ $ctrl.loading ? 'true' : undefined }}"
    ng-attr-aria-label="{{ !$ctrl.label ? $ctrl.ariaLabel : undefined }}"
    ng-attr-aria-labelledby="{{ $ctrl.label ? $ctrl.labelId : undefined }}"
    ng-click="$ctrl.handleClick($event)"
  >
    <span
      ng-if="$ctrl.loading"
      class="ec-animate-spin"
      ng-class="$ctrl.getIconClasses()"
      ng-bind-html="$ctrl.trustedSpinner"
      aria-hidden="true"
    ></span>
    <span
      ng-if="!$ctrl.loading && $ctrl.hasContent"
      ng-class="$ctrl.getIconClasses()"
      ng-transclude
      aria-hidden="true"
    ></span>
    <span
      ng-if="!$ctrl.loading && !$ctrl.hasContent"
      ng-class="$ctrl.getIconClasses()"
      ng-bind-html="$ctrl.trustedIcon"
      aria-hidden="true"
    ></span>
  </button>

  <span
    ng-if="$ctrl.label"
    ng-attr-id="{{ $ctrl.labelId }}"
    ng-class="$ctrl.getLabelClasses()"
  >{{ $ctrl.label }}</span>
</div>
`;

export default FAB_TEMPLATE;
